import {
  actionTypes,
  DateRangeInput,
  DcddUserInput,
  DcddUserProfileProps,
  DcddUserProps,
  GenericProps,
  RegisteredDcddUserProps,
  UpdatePasswordInput,
} from "./actionType";
import { executeMutation, executeQuery } from "utils/services/apiServices";
import { showSnackbar } from "utils/snack_bar/store/action";
import {
  CHECK_EXISTING_DCDD_USER,
  FETCH_DCDD_ACTIVE_USERS,
  FETCH_DCDD_USERS,
  FETCH_DCDD_USERS_BY_DATE_RANGE,
  FETCH_DZONGKHAG,
  FETCH_ECCD,
  FETCH_GRADES,
  FETCH_PROFILE_BY_USER_ID,
  FETCH_SCHOOLS,
} from "../graphql/query";
import { setError } from "utils/flash_error/store/action";
import {
  BULK_REGISTRATION,
  CREATE_DCDD_USER,
  UPDATE_DCDD_USER,
  UPDATE_DCDD_USER_PASSOWRD,
  UPDATE_DCDD_USER_STATUS,
} from "../graphql/mutation";

export const fetchDcddUsersRequest = () => ({
  type: actionTypes.FETCH_DCDD_USERS_REQUEST,
});
export const fetchDcddUsersSuccess = (payload: DcddUserProps[]) => ({
  type: actionTypes.FETCH_DCDD_USERS_SUCCESS,
  payload,
});
export const fetchDcddUsersFail = (payload: string) => ({
  type: actionTypes.FETCH_DCDD_USERS_FAIL,
  payload,
});
export const fetchDcddUsers = (limit:number, offset:number) => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchDcddUsersRequest());
      const response = await executeQuery(FETCH_DCDD_USERS,{limit, offset});
      const jsonData = response.data?.fetchAllDcddUsers;
      if (jsonData?.error === null) {
        dispatch(fetchDcddUsersSuccess(jsonData.data));
      } else {
        dispatch(fetchDcddUsersFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchDcddUsersFail("Failed to fetch dcdd users"));
    }
  };
};
//fetch active user
export const fetchDcddActiveUsersRequest = () => ({
  type: actionTypes.FETCH_DCDD_ACTIVE_USERS_REQUEST,
});
export const fetchDcddActiveUsersSuccess = (payload: RegisteredDcddUserProps[]) => ({
  type: actionTypes.FETCH_DCDD_ACTIVE_USERS_SUCCESS,
  payload,
});
export const fetchDcddActiveUsersFail = (payload: string) => ({
  type: actionTypes.FETCH_DCDD_ACTIVE_USERS_FAIL,
  payload,
});
export const fetchDcddActiveUsers = (limit:number, offset:number) => {
  return async (dispatch: any) => {
    try {
      dispatch(fetchDcddActiveUsersRequest());
      const response = await executeQuery(FETCH_DCDD_ACTIVE_USERS, {limit, offset});
      const jsonData = response.data?.GetDcddUserActivity;
      if (jsonData?.error === null) {
        dispatch(fetchDcddActiveUsersSuccess(jsonData.data));
      } else {
        dispatch(fetchDcddActiveUsersFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error:${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong!"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(fetchDcddActiveUsersFail("Failed to fetch dcdd active users"));
    }
  };
};

//fetch user by date range
export const fetchDcddUsersByDateRangeRequest = () => ({
  type: actionTypes.FETCH_DCDD_USERS_BY_DATE_RANGE_REQUEST,
});
export const fetchDcddUsersByDateRangeSuccess = (payload: RegisteredDcddUserProps[]) => ({
  type: actionTypes.FETCH_DCDD_USERS_BY_DATE_RANGE_SUCCESS,
  payload,
});
export const fetchDcddUsersByDateRangeFail = (payload: string) => ({
  type: actionTypes.FETCH_DCDD_USERS_BY_DATE_RANGE_FAIL,
  payload,
});
export const fetchDcddUsersByDateRange = (input: DateRangeInput) => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchDcddUsersByDateRangeRequest());
      const response = await executeQuery(
        FETCH_DCDD_USERS_BY_DATE_RANGE,
        input
      );
      const jsonData = response.data?.FetchDcddUsersByDateRange;
      if (jsonData?.error === null) {
        dispatch(fetchDcddUsersByDateRangeSuccess(jsonData.data));
        dispatch(showSnackbar("Success! user fetched"));
      } else {
        dispatch(fetchDcddUsersByDateRangeFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error:${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong!"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(fetchDcddUsersByDateRangeFail("Failed to fetch dcdd users"));
    }
  };
};
//fetchDcddUserProfileUsingUserId
export const fetchDcddUserProfileByUserIdRequest = () => ({
  type: actionTypes.FETCH_DCDD_USER_PROFILE_BY_USER_ID_REQUEST,
});
export const fetchDcddUserProfileByUserIdSuccess = (
  payload: DcddUserProfileProps
) => ({
  type: actionTypes.FETCH_DCDD_USER_PROFILE_BY_USER_ID_SUCCESS,
  payload,
});
export const fetchDcddUserProfileByUserIdFail = (payload: string) => ({
  type: actionTypes.FETCH_DCDD_USER_PROFILE_BY_USER_ID_FAIL,
  payload,
});
export const fetchDcddUserProfileByUserId = (user_id: string) => {
  return async (dispatch: any) => {
    try {
      const input_Data = {
        user_id: user_id,
      };
      await dispatch(fetchDcddUserProfileByUserIdRequest());
      const response = await executeQuery(FETCH_PROFILE_BY_USER_ID, input_Data);
      const jsonData = response.data?.FetchProfileByDcddUserId;
      if (jsonData?.error === null) {
        dispatch(
          fetchDcddUserProfileByUserIdSuccess(jsonData?.data.user_profile)
        );
        dispatch(showSnackbar("Success! user fetched"));
      } else {
        dispatch(fetchDcddUserProfileByUserIdFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error:${jsonData?.error.message}`));
      }
    } catch (error: any) {
      dispatch(fetchDcddUserProfileByUserIdFail("Failed to fetch dcdd user profile"));
    }
  };
};

//CheckForExistingDcddUserByMobile
export const checkForExistingDcddUserByMobileResuest = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_REQUEST,
});
export const checkForExistingDcddUserByMobileSuccess = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_SUCCESS,
});
export const checkForExistingDcddUserByMobileFail = (payload: string) => ({
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_FAIL,
  payload,
});
export const checkForExistingDcddUserByMobile = (data: String) => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkForExistingDcddUserByMobileResuest());
      const input = {
        field: "mobile_no",
        value: data,
      };
      const response = await executeQuery(CHECK_EXISTING_DCDD_USER, input);
      const jsonData = response.data?.checkForExistingDcddUser;
      if (jsonData?.error === null && !jsonData?.data.exist_user) {
        dispatch(checkForExistingDcddUserByMobileSuccess());
      } else {
        dispatch(
          setError(
            jsonData?.error?.message ??
              "User with given mobile no already exist"
          )
        );
        dispatch(
          checkForExistingDcddUserByMobileFail(
            jsonData?.error?.message ??
              "User with given mobile no already exist"
          )
        );
      }
    } catch (error: any) {
      dispatch(checkForExistingDcddUserByMobileFail("Something went wrong"));
    }
  };
};

//CheckForExistingDcddUserByEmail
export const checkForExistingDcddUserByEmailResuest = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_REQUEST,
});
export const checkForExistingDcddUserByEmailSuccess = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_SUCCESS,
});
export const checkForExistingDcddUserByEmailFail = (payload: string) => ({
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_FAIL,
  payload,
});
export const checkForExistingDcddUserByEmail = (data: string) => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkForExistingDcddUserByEmailResuest());
      const input = {
        field: "email",
        value: data,
      };
      const response = await executeQuery(CHECK_EXISTING_DCDD_USER, input);
      const jsonData = response.data?.checkForExistingDcddUser;
      if (jsonData?.error === null && !jsonData?.data.exist_user) {
        dispatch(checkForExistingDcddUserByEmailSuccess());
      } else {
        dispatch(
          checkForExistingDcddUserByEmailFail(
            jsonData?.error?.message ?? "User with given email already exist"
          )
        );
      }
    } catch (error: any) {
      dispatch(checkForExistingDcddUserByEmailFail("Something went wrong"));
    }
  };
};

//RESET
export const ResetDcddUserDetails = () => ({
  type: actionTypes.RESET_DCDD_DETAILS,
});

export const resetDcddUserDetails = () => {
  return async (dispatch: any) => {
    dispatch(ResetDcddUserDetails());
  };
};

//fetch dzongkhage
export const fetchDzongkhagRequest = () => ({
  type: actionTypes.FETCH_DZONGKHAG_REQUEST,
});
export const fetchDzongkhagSuccess = (payload: GenericProps[]) => ({
  type: actionTypes.FETCH_DZONGKHAG_SUCCESS,
  payload,
});
export const fetchDzongkhagFail = (payload: string) => ({
  type: actionTypes.FETCH_DZONGKHAG_FAIL,
  payload,
});

export const fetchDzongkhag = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchDzongkhagRequest());
      const response = await executeQuery(FETCH_DZONGKHAG);
      const jsonData = response.data?.fetchDzongkhag;
      if (jsonData?.error === null) {
        dispatch(fetchDzongkhagSuccess(jsonData.data.dzongkhags));
        dispatch(showSnackbar("Success! dzongkhag fetched"));
      } else {
        dispatch(fetchDzongkhagFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error:${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong!"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(fetchDzongkhagFail("Failed to fetch dzongkhag"));
    }
  };
};
//fetch schools
export const fetchSchoolsRequest = () => ({
  type: actionTypes.FETCH_SCHOOLS_REQUEST,
});
export const fetchSchoolsSuccess = (payload: GenericProps[]) => ({
  type: actionTypes.FETCH_SCHOOLS_SUCCESS,
  payload,
});
export const fetchSchoolsFail = (payload: string) => ({
  type: actionTypes.FETCH_SCHOOLS_FAIL,
  payload,
});
export const fetchSchools = (dzongkhag_id: string) => {
  return async (dispatch: any) => {
    try {
      const input = {
        dzongkhag_id: dzongkhag_id,
      };
      await dispatch(fetchSchoolsRequest());
      const response = await executeQuery(FETCH_SCHOOLS, input);
      const jsonData = response.data?.fetchSchools;
      if (jsonData?.error === null) {
        dispatch(fetchSchoolsSuccess(jsonData.data.school));
        dispatch(showSnackbar("Success! school fetched"));
      } else {
        dispatch(fetchSchoolsFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error:${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong!"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(fetchSchoolsFail("Failed to fetch school"));
    }
  };
};
//fetch eccd
export const fetchEccdRequest = () => ({
  type: actionTypes.FETCH_ECCD_REQUEST,
});
export const fetchEccdSuccess = (payload: GenericProps[]) => ({
  type: actionTypes.FETCH_ECCD_SUCCESS,
  payload,
});
export const fetchEccdFail = (payload: string) => ({
  type: actionTypes.FETCH_ECCD_FAIL,
  payload,
});
export const fetchEccd = (dzongkhag_id: string) => {
  return async (dispatch: any) => {
    try {
      const input = {
        dzongkhag_id: dzongkhag_id,
      };
      await dispatch(fetchEccdRequest());
      const response = await executeQuery(FETCH_ECCD, input);
      const jsonData = response.data?.fetchEccd;
      if (jsonData?.error === null) {
        dispatch(fetchEccdSuccess(jsonData.data.eccd));
        dispatch(showSnackbar("Success! eccd fetched"));
      } else {
        dispatch(fetchEccdFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error:${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong!"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(fetchEccdFail("Failed to fetch eccd"));
    }
  };
};
//fetch grades
export const fetchGradesRequest = () => ({
  type: actionTypes.FETCH_GRADES_REQUEST,
});
export const fetchGradesSuccess = (payload: GenericProps[]) => ({
  type: actionTypes.FETCH_GRADES_SUCCESS,
  payload,
});
export const fetchGradesFail = (payload: string) => ({
  type: actionTypes.FETCH_GRADES_FAIL,
  payload,
});
export const fetchGrades = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchGradesRequest());
      const response = await executeQuery(FETCH_GRADES);
      const jsonData = response.data?.fetchGrade;
      if (jsonData?.error === null) {
        dispatch(fetchGradesSuccess(jsonData.data.grade));
        dispatch(showSnackbar("Success! grade fetched"));
      } else {
        dispatch(fetchGradesFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error:${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong!"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(fetchGradesFail("Failed to fetch grade"));
    }
  };
};

//createDcddUser
export const createDcddUserRequest = () => ({
  type: actionTypes.CREATE_DCDD_USER_REQUEST,
});
export const createDcddUserSuccess = (payload: RegisteredDcddUserProps) => ({
  type: actionTypes.CREATE_DCDD_USER_SUCCESS,
  payload,
});
export const createDcddUserFail = (payload: string) => ({
  type: actionTypes.CREATE_DCDD_USER_FAIL,
  payload,
});
export const createDcddUser = (signup_input: DcddUserInput) => {
  return async (dispatch: any) => {
    try {
      const input_data = {
        signup_input: signup_input,
      };
      dispatch(createDcddUserRequest());
      const response = await executeMutation(CREATE_DCDD_USER, input_data);
      const jsonData = response.data?.createDcddUser;
      if (jsonData?.error === null) {
        dispatch(createDcddUserSuccess(jsonData?.data)); // Use the user object
        dispatch(showSnackbar("Success! User created."));
      } else {
        dispatch(createDcddUserFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error: ${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(createDcddUserFail("Failed to create user."));
    }
  };
};
//updateDcddUser
export const updateDcddUserRequest = () => ({
  type: actionTypes.UPDATE_DCDD_USER_REQUEST,
});
export const updateDcddUserSuccess = (payload: RegisteredDcddUserProps) => ({
  type: actionTypes.UPDATE_DCDD_USER_SUCCESS,
  payload,
});
export const updateDcddUserFail = (payload: string) => ({
  type: actionTypes.UPDATE_DCDD_USER_FAIL,
  payload,
});
export const updateDcddUser = (
  user_id: string,
  signup_input: DcddUserInput
) => {
  return async (dispatch: any) => {
    try {
      const input_data = {
        user_id: user_id,
        signup_input: signup_input,
      };
      dispatch(updateDcddUserRequest());
      const response = await executeMutation(UPDATE_DCDD_USER, input_data);
      const jsonData = response.data?.updateDcddUser;
      if (jsonData?.error === null) {
        dispatch(updateDcddUserSuccess(jsonData?.data)); // Use the user object
        dispatch(showSnackbar("Success! User updated."));
      } else {
        dispatch(updateDcddUserFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error: ${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(updateDcddUserFail("Failed to update user."));
    }
  };
};
//updateDcddUserPassword
export const updateDcddUserPasswordRequest = () => ({
  type: actionTypes.UPDATE_DCDD_USER_PASSWORD_REQUEST,
});
export const updateDcddUserPasswordSuccess = (payload: RegisteredDcddUserProps) => ({
  type: actionTypes.UPDATE_DCDD_USER_PASSWORD_SUCCESS,
  payload,
});
export const updateDcddUserPasswordFail = (payload: string) => ({
  type: actionTypes.UPDATE_DCDD_USER_PASSWORD_FAIL,
  payload,
});
export const updateDcddUserPassword = (
  user_id: string,
  ResetPasswordInput: UpdatePasswordInput
) => {
  return async (dispatch: any) => {
    try {
      const input_data = {
        user_id: user_id,
        ResetPasswordInput: ResetPasswordInput,
      };
      dispatch(updateDcddUserPasswordRequest());
      const response = await executeMutation(UPDATE_DCDD_USER_PASSOWRD, input_data);
      const jsonData = response.data?.updateDcddUserPassword;
      if (jsonData?.error === null) {
        dispatch(updateDcddUserPasswordSuccess(jsonData?.data)); // Use the user object
        dispatch(showSnackbar("Success! User updated."));
      } else {
        dispatch(updateDcddUserPasswordFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error: ${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(updateDcddUserPasswordFail("Failed to update user."));
    }
  };
};

//updateDcddUserStatus
export const updateDcddUserStatusRequest = () => ({
  type: actionTypes.UPDATE_DCDD_USER_STATUS_REQUEST,
});
export const updateDcddUserStatusSuccess = (payload: DcddUserProps) => ({
  type: actionTypes.UPDATE_DCDD_USER_STATUS_SUCCESS,
  payload,
});
export const updateDcddUserStatusFail = (payload: string) => ({
  type: actionTypes.UPDATE_DCDD_USER_STATUS_FAIL,
  payload,
});
export const updateDcddUserStatus = (userID: string, status: string) => {
  return async (dispatch: any) => {
    try {
      const input_data = {
        userID: userID,
        status: status,
      };
      dispatch(updateDcddUserStatusRequest());
      const response = await executeMutation(
        UPDATE_DCDD_USER_STATUS,
        input_data
      );
      const jsonData = response.data?.UpdateDcddUserStatus;
      if (jsonData?.error === null) {
        dispatch(updateDcddUserStatusSuccess(jsonData?.data.user)); // Use the user object
        dispatch(showSnackbar("Success! User created."));
      } else {
        dispatch(updateDcddUserStatusFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error: ${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(updateDcddUserStatusFail("Failed to update user status."));
    }
  };
};

//bulkRegistration
export const bulkRegistrationRequest = () => ({
  type: actionTypes.BULK_REGISTRATION_REQUEST,
});
export const bulkRegistrationSuccess = (payload: string) => ({
  type: actionTypes.BULK_REGISTRATION_SUCCESS,
  payload,
});
export const bulkRegistrationFail = (payload: string) => ({
  type: actionTypes.BULK_REGISTRATION_FAIL,
  payload,
});
export const bulkRegistration = (csv_path?: string) => {
  return async (dispatch: any) => {
    try {
      const input_data = {
        csv_path: csv_path,
      };
      dispatch(bulkRegistrationRequest());
      const response = await executeMutation(
        BULK_REGISTRATION,
        input_data
      );
      const jsonData = response.data?.bulkRegistration;
      if (jsonData?.error === null) {
        dispatch(bulkRegistrationSuccess(jsonData?.data));
        dispatch(showSnackbar("Success! User registered."));
      } else {
        dispatch(bulkRegistrationFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error: ${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(bulkRegistrationFail("Failed to register users."));
    }
  };
};
